import { FormattedMessage, useIntl } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const ReportingAndInsightsSpork = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "jira-software-pricing.modal-content.reporting-and-insights-spork.title",
            defaultMessage: "Reports and team insights"
        }),
        body: intl.formatMessage({
            id: "jira-software-pricing.modal-content.reporting-and-insights-spork.body",
            defaultMessage:
                "Access out-of-the-box reports with real-time, actionable insights on how your team is performing over time."
        }),
        bodyTwo: intl.formatMessage({
            id: "jira-software-pricing.modal-content.reporting-and-insights-spork.bodyTwo",
            defaultMessage:
                "Bring reports into a dashboard to have all your data in a single view for fast, informed decision-making."
        })
    };
    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
            <p>{messages.bodyTwo}</p>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.reporting-and-insights-spork.learnMore"
                    defaultMessage="<learnMore>Learn more</learnMore> about reporting in Jira."
                    values={{
                        ...DEFAULT_VALUES,
                        learnMore: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="jiraSoftware"
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                href={useLocalizedHref(
                                    "/software/jira/features/reports"
                                )}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};

export default ReportingAndInsightsSpork;
